import React from 'react';
import { Button, useDataProvider, useRecordContext, useResourceContext } from 'react-admin';

export const TestPush: React.FC = () => {
  const record = useRecordContext();
  const dataProvider = useDataProvider();
  const resource = useResourceContext()

  const sendTestPush = async () => {
    await (dataProvider as any).sendTestPush(resource, record.id);
  }

  return (
    <Button label="Send Test Push" onClick={sendTestPush} />
  );
}
